import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex);
export default {
    namespaced: true,
    state: {
        selectedProducts: [],
        selectedPriceOption: {},
        quote: {},
        stripe: {
            sessionId: null,
        },
        savedQuote: {},
        uuid: null,
        postcode: null,
        serviceTypes: [],
    },
    mutations: {
        setUuid: function (state, uuid) {
            state.uuid = uuid;
        },
        setSelectedProducts: function (state, selectedProducts) {
            state.selectedProducts = selectedProducts;
        },
        addSelectedProduct: function (state, selectedProduct) {
            state.selectedProducts.push(selectedProduct);
        },
        setQuote: function (state, quote) {
            state.quote = quote;
        },
        setSelectedPriceOption: function (state, selectedPriceOption) {
            state.selectedPriceOption = selectedPriceOption;
        },
        setStripeSessionId: function (state, sessionId) {
            state.stripe.sessionId = sessionId;
        },
        setSavedQuote: function (state, savedQuote) {
            state.savedQuote = savedQuote;
        },
        setPostcode: function (state, postcode) {
            state.postcode = postcode;
        },
    },
    actions: {},
    getters: {
        selectedProducts: function (state) { return state.selectedProducts; },
        quote: function (state) { return state.quote; },
        selectedPriceOption: function (state) { return state.selectedPriceOption; },
        stripeSessionId: function (state) { return state.stripe.sessionId; },
        savedQuote: function (state) { return state.savedQuote; },
        uuid: function (state) { return state.uuid; },
        postcode: function (state) { return state.postcode; },
        serviceTypes: function (state) { return state.serviceTypes; },
    }
};
